import { render, staticRenderFns } from "./relCaseDialog.vue?vue&type=template&id=41cce512"
import script from "./relCaseDialog.vue?vue&type=script&lang=js"
export * from "./relCaseDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports